import { useEffect, useState } from "react";

const links = [
  { href: "#work", label: "Work", id: "work" },
  { href: "#services", label: "Services", id: "services" },
  { href: "#technology", label: "Technology", id: "technology" },
  { href: "#about", label: "About", id: "about" },
];

export const Navigation = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [active, setActive] = useState("");

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 18);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    if (!("IntersectionObserver" in window)) return undefined;
    const sections = [...links.map((link) => document.getElementById(link.id)), document.getElementById("contact")].filter(Boolean);
    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries.filter((entry) => entry.isIntersecting).sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
        if (visible) setActive(visible.target.id);
      },
      { rootMargin: "-28% 0px -56% 0px", threshold: [0, 0.1, 0.3] }
    );
    sections.forEach((section) => observer.observe(section));
    return () => observer.disconnect();
  }, []);

  const closeMenu = () => setOpen(false);

  return (
    <nav className={`site-nav ${scrolled ? "site-nav--scrolled" : ""}`} aria-label="주요 메뉴">
      <div className="nav-inner">
        <a className="brand" href="#top" aria-label="IRUN 홈" onClick={closeMenu}>
          <span className="brand-mark" aria-hidden="true"><i>i</i></span>
          <span>IRUN</span>
        </a>

        <button
          className={`nav-toggle ${open ? "nav-toggle--open" : ""}`}
          type="button"
          aria-expanded={open}
          aria-controls="nav-menu"
          onClick={() => setOpen((value) => !value)}
        >
          <span /><span /><span className="sr-only">메뉴 열기</span>
        </button>

        <div id="nav-menu" className={`nav-menu ${open ? "nav-menu--open" : ""}`}>
          {links.map((link) => (
            <a key={link.href} href={link.href} onClick={closeMenu} className={active === link.id ? "is-active" : ""}>
              {link.label}<i aria-hidden="true" />
            </a>
          ))}
          <a className={`nav-cta ${active === "contact" ? "is-active" : ""}`} href="#contact" onClick={closeMenu}>
            프로젝트 문의 <span aria-hidden="true">↗</span>
          </a>
        </div>
      </div>
    </nav>
  );
};
